import * as yup from 'yup';

export const getProspectsDIRFilterSchema = yup.object().shape({
  commercialIds: yup.array().of(yup.string()),
});
